export default "__VITE_ASSET__F__P2BbZ__"